<template>
  <div></div>
</template>
<script>
import { mapGetters } from "vuex";
import { clientService } from "../services/clientService";

export default {
  name: "Jump",
  computed: {
    ...mapGetters({
      user: "user", // 用户信息
      client: "client", // 客户端信息
    }),
  },
  mounted() {
    // 获取用户信息
    this.$store.dispatch('getEnv').then(() => {
      this.$store.dispatch('appInfoInitialize')
        .then(() => {
          setTimeout(()=>{
            if (this.client.env != "app") {
              // 只能在APP中运行
              return;
            }
            if (!this.user.token) {
              this.login()
              return
            }
            this.getBankCard()
          }, 200)
          
        })
    })
    
  },
  methods: {
    getBankCard(){
      this.$store
      .dispatch("getBankCard")
      .then((data) => {
        // this.$spinner.close();
        if (data === "h5loginExpired") {
          this.login();
          return;
        }
        if (data.success) {
          let cardInfo = {}
          if (data.datas && data.datas.length > 0) {
            let tip = false;
            for (let i = 0; i < data.datas.length; i++) {
              if (
                data.datas[i].state === "ACTIVATED" &&
                (data.datas[i].mediumBank === "SPDB" ||
                  data.datas[i].mediumBank === "SPDBANK")
              ) {
                cardInfo = data.datas[i];
                tip = true;
                break;
              }
            }
            if (tip) {
              // this.toggleShowCbc(true)
              window.location.href = cardInfo.successFulLink
            } else {
              this.$toast("您没有浦发三类账户");
            }
          } else {
            this.$toast("您没有浦发三类账户");
          }
        } else {
          if (data.errorCode === "410014") {
            // 银行卡不存在
            this.$toast("您没有浦发三类账户");
          } else {
            this.$toast("服务器异常，请稍后重试");
          }
        }
      })
      .catch(() => {
        // this.$spinner.close();
        this.$toast("服务器异常，请稍后重试");
      });
    },
    // 登录 APP
    login() {
      let { env } = this.client;
      if (env === "app") {
        // FZSapp
        /* eslint-disable no-undef */
        clientService.jumpToLogin({}, (data) => {
          if (data && data.isLogin) {
            window.location.reload();
          }
        });
      }
    },
  },
};
</script>